export default __webpack_public_path__ + "static/media/J724_CoC.0854e1db.pdf";